/* eslint-disable max-lines */
import { POST_FIELDS, OPERATION } from '@/services/charts-service';
import {
  DEFAULT_SIZES,
  DATA_TYPE,
  WIDTH,
  HEIGHT,
  FILTER_NAMES,
  COMPONENT_TYPE,
} from '@/store/modules/cards/constants';
import { Flags } from '@/plugins/rollout';
/*
  Property of allowCards objects:

  id: String,
  width: Enum DEFAULT_SIZES,
  height: Enum DEFAULT_SIZES,
  component: String,
  visible: Boolean,
  hideExpandButton: Boolean,
  hideResizeButton: Boolean,
  notSupportFilter: Boolean,
  dataType: Enum DATA_TYPE,
  props: Object,
*/
export default [
  {
    id: 'LSN_1',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'CollectedPosts',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Publicações',
      originalTitle: 'Publicações',
      isExpandedCard: false,
      description: 'Somatória de publicações coletadas na pesquisa.',
      tags: 'Menções e Publicações',
    },
  },
  {
    id: 'LSN_2',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'CollectedUsers',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Usuários',
      originalTitle: 'Usuários',
      isExpandedCard: false,
      description: 'Contagem de usuários únicos que geraram o total de publicações na pesquisa.',
      tags: 'Usuários e Influenciadores',
    },
  },
  {
    id: 'LSN_3',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'NPS',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Net Promoter Score',
      originalTitle: 'Net Promoter Score',
      isExpandedCard: false,
      description: 'Representa o resultado da equação: (publicações positivas / publicações coletadas * 100) - (publicações negativas / publicações coletadas * 100).',
      tags: 'Sentimento',
    },
  },
  {
    id: 'LSN_4',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'PotentialReach',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Alcance Potencial',
      originalTitle: 'Alcance Potencial',
      isExpandedCard: false,
      description: 'Representa 20% da somatória de seguidores/inscritos dos perfis coletados na pesquisa.',
      tags: 'Menções e Publicações',
    },
  },
  {
    id: 'LSN_5',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'SentimentIndex',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Índice de sentimento',
      originalTitle: 'Índice de sentimento',
      isExpandedCard: false,
      description: 'Representa o resultado da equação: (publicações positivas + publicações neutras - publicações negativas) / total de publicações.',
      tags: 'Sentimento',
    },
  },
  {
    id: 'LSN_6',
    width: DEFAULT_SIZES.pieChart.width,
    height: DEFAULT_SIZES.pieChart.height,
    component: 'SentimentPieChart',
    componentType: COMPONENT_TYPE.DONUT,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Distribuição por Sentimento',
      originalTitle: 'Distribuição por Sentimento',
      isExpandedCard: false,
      description: 'Divisão das publicações por polaridade positiva, negativa ou neutra.',
      tags: 'Sentimento',
    },
  },
  {
    id: 'LSN_7',
    width: DEFAULT_SIZES.pieChart.width,
    height: DEFAULT_SIZES.pieChart.height,
    component: 'GenderPieChart',
    componentType: COMPONENT_TYPE.DONUT,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Distribuição por Gênero',
      originalTitle: 'Distribuição por Gênero',
      isExpandedCard: false,
      description: 'Divisão das publicações por Homem, Mulher e Organização.',
      tags: 'Demográficos',
    },
  },
  {
    id: 'LSN_8',
    width: DEFAULT_SIZES.pieChart.width,
    height: DEFAULT_SIZES.pieChart.height,
    component: 'DevicePieChart',
    componentType: COMPONENT_TYPE.DONUT,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Distribuição por Dispositivo',
      originalTitle: 'Distribuição por Dispositivo',
      isExpandedCard: false,
      description: 'Divisão das publicações por Celular/Tablet e Computador',
      tags: 'Demográficos',
    },
  },
  {
    id: 'LSN_9',
    width: DEFAULT_SIZES.pieChart.width,
    height: DEFAULT_SIZES.pieChart.height,
    component: 'ChannelPieChart',
    componentType: COMPONENT_TYPE.DONUT,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Distribuição por Canal',
      originalTitle: 'Distribuição por Canal',
      isExpandedCard: false,
      description: 'Divisão das publicações por canal de coleta (listening).',
      tags: 'Demográficos',
    },
  },
  {
    id: 'LSN_10',
    width: WIDTH.MID,
    height: HEIGHT.LARGE,
    component: 'TopInfluencers',
    componentType: COMPONENT_TYPE.RANKING,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    shareable: false,
    props: {
      title: 'Principais Influenciadores',
      originalTitle: 'Principais Influenciadores',
      isExpandedCard: false,
      description: 'Ranking de influenciadores ordenados pela metodologia AAA (grau de influência composto por Atratividade ao Conteúdo, Afinidade com a Pesquisa e Alcance do influenciador).',
      tags: 'Usuários e Influenciadores',
    },
  },
  {
    id: 'LSN_11',
    width: WIDTH.MID,
    height: HEIGHT.XLARGE,
    component: 'TopPosts',
    componentType: COMPONENT_TYPE.CARD,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    shareable: false,
    props: {
      title: 'Publicações mais quentes',
      originalTitle: 'Publicações mais quentes',
      isExpandedCard: false,
      description: 'Top publicações ordenadas em carrossel pela ponderação entre o tempo da postagem e engajamento recebido recentemente.',
      tags: 'Menções e Publicações',
    },
  },
  {
    id: 'LSN_12',
    width: WIDTH.LARGE,
    height: HEIGHT.LARGE,
    component: 'TopTerms',
    componentType: COMPONENT_TYPE.NETWORK,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Termos correlacionados',
      originalTitle: 'Termos correlacionados',
      isExpandedCard: false,
      description: 'Apresenta os principais termos relacionados à pesquisa dentro de um intervalo de tempo. Proximidade indica grau de relação. Tamanho das bolas indica volume de publicações.',
      tags: 'Termos',
    },
  },
  {
    id: 'LSN_13',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'PostInTime',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Publicações no tempo',
      originalTitle: 'Publicações no tempo',
      isExpandedCard: false,
      description: 'Distribuição linear das publicações coletadas ao longo de um período de tempo.',
      tags: 'Menções e Publicações',
    },
  },
  {
    id: 'LSN_14',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'SentimentInTime',
    componentType: COMPONENT_TYPE.STACKED_AREA,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Sentimento no tempo',
      originalTitle: 'Sentimento no tempo',
      isExpandedCard: false,
      description: 'Distribuição de publicações por sua polaridade ao longo de um período de tempo.',
      tags: 'Sentimento',
    },
  },
  {
    id: 'LSN_15',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'TermMultibarChart',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Sentimento por termo',
      originalTitle: 'Sentimento por termo',
      isExpandedCard: false,
      description: 'Distribuição de publicações por termos mais mencionados e sua divisão de polaridade.',
      tags: 'Termos; Sentimento',
    },
  },
  {
    id: 'LSN_16',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'GroupMultibarChart',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Sentimento por grupo',
      originalTitle: 'Sentimento por grupo',
      isExpandedCard: false,
      description: 'Distribuição de publicações pelos Grupos cadastrados na pesquisa mais mencionados e sua divisão de polaridade.',
      tags: 'Sentimento, Categorias e Anotações',
    },
  },
  {
    id: 'LSN_17',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'ThemeMultibarChart',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Sentimento por tema',
      originalTitle: 'Sentimento por tema',
      isExpandedCard: false,
      description: 'Distribuição de publicações pelos Temas cadastrados na pesquisa mais mencionados e sua divisão de polaridade.',
      tags: 'Sentimento, Categorias e Anotações',
    },
  },
  {
    id: 'LSN_18',
    width: WIDTH.LARGE,
    height: HEIGHT.MID,
    component: 'AnnotationTextCard',
    componentType: COMPONENT_TYPE.TEXT,
    visible: true,
    notSupportFilter: true,
    dataType: DATA_TYPE.STATIC,
    props: {
      title: 'Anotações de texto',
      originalTitle: 'Anotações de texto',
      isExpandedCard: false,
      noPadding: true,
      text: '',
      description: 'Espaço de texto editável livre para escrever análises, legendas e/ou observações.',
      tags: 'Personalização',
    },
  },
  {
    id: 'LSN_19',
    width: WIDTH.LARGE,
    height: HEIGHT.MID,
    component: 'AnnotationImageCard',
    componentType: COMPONENT_TYPE.IMAGE,
    visible: true,
    notSupportFilter: true,
    dataType: DATA_TYPE.STATIC,
    props: {
      title: 'Inserir Imagem',
      originalTitle: 'Inserir Imagem',
      isExpandedCard: false,
      noPadding: true,
      description: 'Componente para inserir imagens por arquivo ou via URLs.',
      tags: 'Personalização',
    },
  },
  {
    id: 'LSN_20',
    width: WIDTH.LARGE,
    height: HEIGHT.MID,
    component: 'ChannelInTimeChart',
    componentType: COMPONENT_TYPE.VERTICAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Canais no Tempo',
      originalTitle: 'Canais no Tempo',
      isExpandedCard: false,
      description: 'Distribuição das publicações coletadas divididas por canal de coleta ao longo de um período de tempo.',
      tags: 'Canais',
    },
  },
  {
    id: 'LSN_21',
    width: WIDTH.SMALL,
    height: HEIGHT.SMALL,
    component: 'NpsGauge',
    componentType: COMPONENT_TYPE.GAUGE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Termômetro de Sentimento',
      originalTitle: 'Termômetro de Sentimento',
      isExpandedCard: false,
      description: 'Representa, em forma de gauge, o resultado da equação: (publicações positivas / publicações coletadas * 100) - (publicações negativas / publicações coletadas * 100).',
      tags: 'Sentimento',
    },
  },
  {
    id: 'LSN_22',
    width: WIDTH.LARGE,
    height: HEIGHT.LARGE,
    component: 'TopLikedPosts',
    componentType: COMPONENT_TYPE.CARD,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    shareable: false,
    props: {
      title: 'Publicações mais curtidas',
      originalTitle: 'Publicações mais curtidas',
      isExpandedCard: false,
      description: 'Cards em forma de lista ordenada por volume de curtidas em publicações coletadas na pesquisa (inclui posts, publicações e interações).',
      tags: 'Menções e Publicações',
    },
  },
  {
    id: 'LSN_23',
    width: WIDTH.LARGE,
    height: HEIGHT.LARGE,
    component: 'NewPosts',
    componentType: COMPONENT_TYPE.CARD,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    shareable: false,
    props: {
      title: 'Publicações mais recentes',
      originalTitle: 'Publicações mais recentes',
      isExpandedCard: false,
      description: 'Cards em forma de lista ordenada por tempo de publicações coletadas na pesquisa (inclui posts, publicações e interações).',
      tags: 'Menções e Publicações',
    },
  },
  {
    id: 'LSN_24',
    width: WIDTH.LARGE,
    height: HEIGHT.MID,
    component: 'TermsWordCloudChart',
    componentType: COMPONENT_TYPE.WORD_CLOUD,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Nuvem de Termos',
      originalTitle: 'Nuvem de Termos',
      isExpandedCard: false,
      description: 'Apresenta em forma de nuvem os termos mais citados relacionados à pesquisa.',
      tags: 'Termos',
    },
  },
  {
    id: 'LSN_25',
    width: WIDTH.COL12,
    height: HEIGHT.AUTO,
    component: 'SessionDivider',
    componentType: COMPONENT_TYPE.SECTION,
    visible: true,
    notSupportFilter: true,
    hideMenu: true,
    dataType: DATA_TYPE.STATIC,
    props: {
      title: 'Divisor de seção',
      originalTitle: 'Divisor de seção',
      isExpandedCard: false,
      text: 'Divisor de seção',
      noPadding: true,
      description: 'Campo de texto para títulos de segmentos e seções do dashboard.',
      annotation: '',
      tags: 'Personalização',
    },
  },
  {
    id: 'LSN_26',
    width: WIDTH.LARGE,
    height: HEIGHT.LARGE,
    component: 'TopPostsByFollowers',
    componentType: COMPONENT_TYPE.CARD,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    shareable: false,
    props: {
      title: 'Publicações com mais seguidores',
      originalTitle: 'Publicações com mais seguidores',
      isExpandedCard: false,
      description: 'Cards em forma de lista ordenada pela quantidade de seguidores do perfil da publicação.',
      tags: 'Menções e Publicações; Usuários e Influenciadores',
    },
  },
  {
    id: 'LSN_27',
    width: WIDTH.LARGE,
    height: HEIGHT.LARGE,
    component: 'TopPostsByInteractions',
    componentType: COMPONENT_TYPE.CARD,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    shareable: false,
    props: {
      title: 'Publicações com maior Engajamento',
      originalTitle: 'Publicações com maior Engajamento',
      isExpandedCard: false,
      description: 'Cards em forma de lista ordenada pelo total de engajamento gerado na publicação.',
      tags: 'Menções e Publicações',
    },
  },
  {
    id: 'LSN_28',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'LikesTotal',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Curtidas',
      originalTitle: 'Curtidas',
      isExpandedCard: false,
      description: 'Somatória das curtidas existentes nas publicações coletadas.',
      tags: 'Engajamento',
    },
  },
  {
    id: 'LSN_29',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'CommentsTotal',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Comentários',
      originalTitle: 'Comentários',
      isExpandedCard: false,
      description: 'Somatória dos comentários existentes nas publicações coletadas.',
      tags: 'Engajamento',
    },
  },
  {
    id: 'LSN_30',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'SharesTotal',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Compartilhamentos',
      originalTitle: 'Compartilhamentos',
      isExpandedCard: false,
      description: 'Somatória dos compartilhamentos existentes nas publicações coletadas.',
      tags: 'Engajamento',
    },
  },
  {
    id: 'LSN_31',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'InteractionsTotal',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Engajamento',
      originalTitle: 'Engajamento',
      isExpandedCard: false,
      description: 'Somatória de todas as ações de engajamento existentes nas publicações coletadas.',
      tags: 'Engajamento',
    },
  },
  {
    id: 'LSN_32',
    width: WIDTH.LARGE,
    height: HEIGHT.MID,
    component: 'InteractionsInTimeChart',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Engajamento no tempo',
      originalTitle: 'Engajamento no tempo',
      isExpandedCard: false,
      description: 'Somatória de todas as ações de engajamento coletadas em publicações e disposta no período de tempo selecionado.',
      tags: 'Engajamento',
    },
  },
  {
    id: 'LSN_33',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'BaseShareSentiment',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Sentimento por Canal',
      originalTitle: 'Sentimento por Canal',
      isExpandedCard: false,
      description: 'Distribuição de publicações pelos Canais coletados e sua divisão por polaridade.',
      tags: 'Sentimento; Canais',
      group: POST_FIELDS.CHANNEL,
    },
  },
  {
    id: 'LSN_34',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'BaseShareSentiment',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Sentimento por Tag',
      originalTitle: 'Sentimento por Tag',
      isExpandedCard: false,
      description: 'Distribuição de publicações pelas Tags cadastradas na pesquisa e sua divisão por polaridade.',
      tags: 'Sentimento; Categorias e Anotações',
      group: POST_FIELDS.TAG,
      filterName: FILTER_NAMES.TAG,
    },
  },
  {
    id: 'LSN_35',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'BaseShareSentiment',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Sentimento por Gênero',
      originalTitle: 'Sentimento por Gênero',
      isExpandedCard: false,
      description: 'Distribuição de publicações por Gênero e sua divisão por polaridade.',
      tags: 'Sentimento; Demográficos',
      group: POST_FIELDS.GENDER,
    },
  },
  {
    id: 'LSN_36',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BaseTimeSeries',
    componentType: COMPONENT_TYPE.STACKED_LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Menções por Grupo no Tempo',
      originalTitle: 'Menções por Grupo no Tempo',
      isExpandedCard: false,
      description: 'Distribuição de publicações pelos Grupos cadastrados na pesquisa ao longo do tempo.',
      tags: 'Categorias e Anotações',
      group: POST_FIELDS.GROUP,
      filterName: FILTER_NAMES.GROUP,
    },
  },
  {
    id: 'LSN_37',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BaseTimeSeries',
    componentType: COMPONENT_TYPE.STACKED_LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Engajamento por Grupo no Tempo',
      originalTitle: 'Engajamento por Grupo no Tempo',
      isExpandedCard: false,
      description: 'Distribuição da soma das ações de engajamento coletadas nas publicações e classificadas em Grupos da pesquisa ao longo do tempo.',
      tags: 'Categorias e Anotações; Engajamento',
      group: POST_FIELDS.GROUP,
      field: POST_FIELDS.INTERACTIONS,
      operation: OPERATION.SUM,
      filterName: FILTER_NAMES.GROUP,
    },
  },
  {
    id: 'LSN_38',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BaseTimeSeries',
    componentType: COMPONENT_TYPE.STACKED_LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Publicações por Tema no Tempo',
      originalTitle: 'Publicações por Tema no Tempo',
      isExpandedCard: false,
      description: 'Distribuição de publicações pelos Temas cadastrados na pesquisa ao longo do tempo.',
      tags: 'Categorias e Anotações',
      group: POST_FIELDS.THEME,
      filterName: FILTER_NAMES.THEME,
    },
  },
  {
    id: 'LSN_39',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BaseTimeSeries',
    componentType: COMPONENT_TYPE.STACKED_LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Engajamento por Tema no Tempo',
      originalTitle: 'Engajamento por Tema no Tempo',
      isExpandedCard: false,
      description: 'Distribuição da soma das ações de engajamento coletadas nas publicações e classificadas em Temas da pesquisa ao longo do tempo.',
      tags: 'Categorias e Anotações; Engajamento',
      group: POST_FIELDS.THEME,
      field: POST_FIELDS.INTERACTIONS,
      operation: OPERATION.SUM,
      filterName: FILTER_NAMES.THEME,
    },
  },
  {
    id: 'LSN_40',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BaseTimeSeries',
    componentType: COMPONENT_TYPE.STACKED_LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Publicações por Tag no Tempo',
      originalTitle: 'Publicações por Tag no Tempo',
      isExpandedCard: false,
      description: 'Distribuição e publicações pelas Tags atribuídas na pesquisa ao longo do tempo.',
      tags: 'Categorias e Anotações',
      group: POST_FIELDS.TAG,
      filterName: FILTER_NAMES.TAG,
    },
  },
  {
    id: 'LSN_41',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BaseTimeSeries',
    componentType: COMPONENT_TYPE.STACKED_LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Engajamento por Tag no Tempo',
      originalTitle: 'Engajamento por Tag no Tempo',
      isExpandedCard: false,
      description: 'Distribuição da soma das ações de engajamento coletadas nas publicações e classificadas em Tags ao longo do tempo.',
      tags: 'Categorias e Anotações; Engajamento',
      group: POST_FIELDS.TAG,
      field: POST_FIELDS.INTERACTIONS,
      operation: OPERATION.SUM,
      filterName: FILTER_NAMES.TAG,
    },
  },
  {
    id: 'LSN_42',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'BaseShareSentiment',
    componentType: COMPONENT_TYPE.HORIZONTAL_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Engajamento por Grupo',
      originalTitle: 'Engajamento por Grupo',
      isExpandedCard: false,
      description: 'Distribuição da totalidade de interações nas publicações pelos grupos da pesquisa.',
      tags: 'Categorias e Anotações; Engajamento',
      label: 'Total de Engajamento',
      field: POST_FIELDS.INTERACTIONS,
      operation: OPERATION.SUM,
      group: POST_FIELDS.GROUP,
      filterName: FILTER_NAMES.GROUP,
    },
  },
  {
    id: 'LSN_43',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'BaseShareSentiment',
    componentType: COMPONENT_TYPE.HORIZONTAL_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Engajamento por Temas',
      originalTitle: 'Engajamento por Temas',
      isExpandedCard: false,
      description: 'Distribuição da totalidade de interações nas publicações pelos temas da pesquisa.',
      tags: 'Categorias e Anotações; Engajamento',
      label: 'Total de Engajamento',
      field: POST_FIELDS.INTERACTIONS,
      operation: OPERATION.SUM,
      group: POST_FIELDS.THEME,
      filterName: FILTER_NAMES.THEME,
    },
  },
  {
    id: 'LSN_44',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'BaseShareSentiment',
    componentType: COMPONENT_TYPE.HORIZONTAL_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Engajamento por Tags',
      originalTitle: 'Engajamento por Tags',
      isExpandedCard: false,
      description: 'Distribuição da totalidade de interações nas publicações pelas tags da pesquisa ',
      tags: 'Categorias e Anotações; Engajamento',
      label: 'Total de Engajamento',
      field: POST_FIELDS.INTERACTIONS,
      operation: OPERATION.SUM,
      group: POST_FIELDS.TAG,
      filterName: FILTER_NAMES.TAG,
    },
  },
  {
    id: 'LSN_45',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'SentimentInTime',
    componentType: COMPONENT_TYPE.STACKED_LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Sentimento no tempo em percentual',
      originalTitle: 'Sentimento no tempo em percentual',
      isExpandedCard: false,
      description: 'Distribuição de publicações pela proporção percentual de positivas, negativas e neutras ao longo de um período de tempo.',
      tags: 'Sentimento',
      dataType: 'percent',
    },
  },
  {
    id: 'LSN_46',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'BaseShareSentiment',
    componentType: COMPONENT_TYPE.HORIZONTAL_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Publicações por Grupo no Tempo',
      originalTitle: 'Publicações por Grupo no Tempo',
      isExpandedCard: false,
      description: 'Distribuição de publicações pelos Grupos cadastrados na pesquisa.',
      tags: 'Menções e Publicações; Categorias e Anotações',
      label: 'Publicações',
      group: POST_FIELDS.GROUP,
      filterName: FILTER_NAMES.GROUP,
      polarity: false,
      hideNull: true,
    },
  },
  {
    id: 'LSN_47',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'BaseShareSentiment',
    componentType: COMPONENT_TYPE.HORIZONTAL_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Publicações por Tema',
      originalTitle: 'Publicações por Tema',
      isExpandedCard: false,
      description: 'Distribuição de publicações pelos Temas cadastrados na pesquisa.',
      tags: 'Menções e Publicações; Categorias e Anotações',
      label: 'Publicações',
      group: POST_FIELDS.THEME,
      filterName: FILTER_NAMES.THEME,
      polarity: false,
      hideNull: true,
    },
  },
  {
    id: 'LSN_48',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'BaseShareSentiment',
    componentType: COMPONENT_TYPE.HORIZONTAL_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    props: {
      title: 'Publicações por Tag',
      originalTitle: 'Publicações por Tag',
      isExpandedCard: false,
      description: 'Distribuição de publicações pelas Tags atribuídas',
      tags: 'Menções e Publicações; Categorias e Anotações',
      label: 'Publicações',
      group: POST_FIELDS.TAG,
      filterName: FILTER_NAMES.TAG,
      polarity: false,
      hideNull: true,
    },
  },
  {
    id: 'LSN_49',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'VariationOfFanBaseChart',
    componentType: COMPONENT_TYPE.HORIZONTAL_GROUPED_BAR,
    visible: true,
    hideInLibrary: [Flags.showCompetitiveCards],
    notSupportFilter: false,
    dataType: DATA_TYPE.COMPETITIVE,
    props: {
      title: 'Variação de base de fãs (comparativo)',
      originalTitle: 'Variação de base de fãs (comparativo)',
      isExpandedCard: false,
      description: 'Comparação entre total fãs antes da data de início e na data final do período pesquisado (marcas ou concorrentes).',
      tags: 'Performance',
    },
  },
  {
    id: 'LSN_50',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'FansTotalCompetitive',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    hideInLibrary: [Flags.showCompetitiveCards],
    notSupportFilter: false,
    dataType: DATA_TYPE.COMPETITIVE,
    props: {
      title: 'Total de fãs (comparativo)',
      originalTitle: 'Total de fãs (comparativo)',
      isExpandedCard: false,
      description: 'Total de Fãs das páginas selecionadas na data final do período pesquisado (marcas ou concorrentes).',
      tags: 'Performance',
    },
  },
  {
    id: 'LSN_51',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'NewFansCompetitive',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    hideInLibrary: [Flags.showCompetitiveCards],
    notSupportFilter: false,
    dataType: DATA_TYPE.COMPETITIVE,
    props: {
      title: 'Novos fãs (comparativo)',
      originalTitle: 'Novos fãs (comparativo)',
      isExpandedCard: false,
      description: 'Total de fãs conquistados pelas páginas selecionadas no período pesquisado (marcas ou concorrentes).',
      tags: 'Performance',
    },
  },
  {
    id: 'LSN_52',
    width: WIDTH.LARGE,
    height: HEIGHT.MID,
    component: 'FanBaseEvolutionCompetitiveChart',
    componentType: COMPONENT_TYPE.STACKED_LINE,
    visible: true,
    hideInLibrary: [Flags.showCompetitiveCards],
    notSupportFilter: false,
    dataType: DATA_TYPE.COMPETITIVE,
    props: {
      title: 'Evolução da Base de Fãs (comparativo)',
      originalTitle: 'Evolução da Base de Fãs (comparativo)',
      isExpandedCard: false,
      description: 'Variação diária de fãs das páginas pesquisadas no período, relativa ao dia anterior (marcas ou concorrentes).',
      tags: 'Performance',
    },
  },
  {
    id: 'LSN_53',
    width: DEFAULT_SIZES.pieChart.width,
    height: DEFAULT_SIZES.pieChart.height,
    component: 'DistributionMediaPieChart',
    componentType: COMPONENT_TYPE.DONUT,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    hideInLibrary: [Flags.showImpressCards],
    props: {
      title: 'Distribuição por Mídia',
      originalTitle: 'Distribuição por Mídia',
      isExpandedCard: false,
      description: 'Distribuição de publicações por mídia mais mencionados e sua divisão de polaridade.',
      tags: 'Termos; Sentimento; Mídia',
    },
  },
  {
    id: 'LSN_54',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'Valoration',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    hideInLibrary: [Flags.showImpressCards],
    props: {
      title: 'Equivalência Publicitária',
      originalTitle: 'Equivalência Publicitária',
      isExpandedCard: false,
    },
  },
  {
    id: 'LSN_55',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'HighlightsMultibarChart',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    hideInLibrary: [Flags.showImpressCards],
    props: {
      title: 'Destaques Portais',
      originalTitle: 'Destaques Portais',
      isExpandedCard: false,
      channel: 'Portais',
    },
  },
  {
    id: 'LSN_56',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'HighlightsMultibarChart',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    hideInLibrary: [Flags.showImpressCards],
    props: {
      title: 'Destaques TV',
      originalTitle: 'Destaques TV',
      isExpandedCard: false,
      channel: 'TV',
    },
  },
  {
    id: 'LSN_57',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'HighlightsMultibarChart',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    hideInLibrary: [Flags.showImpressCards],
    props: {
      title: 'Destaques Impressas',
      originalTitle: 'Destaques Impressas',
      isExpandedCard: false,
      channel: 'Impressas',
    },
  },
  {
    id: 'LSN_58',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'HighlightsMultibarChart',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    hideInLibrary: [Flags.showImpressCards],
    props: {
      title: 'Destaques Rádio',
      originalTitle: 'Destaques Rádio',
      isExpandedCard: false,
      channel: 'Rádio',
    },
  },
  {
    id: 'LSN_59',
    width: WIDTH.SMALL,
    height: HEIGHT.SMALL,
    component: 'CustomScoreSimpleData',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    hideInLibrary: [Flags.showImpressCards],
    props: {
      title: 'PR Score',
      originalTitle: 'PR Score',
      isExpandedCard: false,
      description: 'Score baseado em uma nota dada às matérias de imprensa.',
      tags: 'Sentimento',
    },
  },
  {
    id: 'LSN_60',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'BrandHealthSimpleData',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    hideInLibrary: [Flags.showBrandHealthCards],
    props: {
      title: 'Saúde da Marca',
      originalTitle: 'Saúde da Marca',
      isExpandedCard: false,
      description: 'Soma o percentual de menções positivas e neutras.',
    },
  },
  {
    id: 'LSN_61',
    width: WIDTH.LARGE,
    height: HEIGHT.LARGE,
    component: 'BrandHealthByGroup',
    componentType: COMPONENT_TYPE.DUAL_AXIS,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    hideInLibrary: [Flags.showBrandHealthCards],
    props: {
      title: 'Saúde da Marca por Grupo',
      originalTitle: 'Saúde da Marca por Grupo',
      isExpandedCard: false,
      description: 'Soma o percentual de menções positivas e neutras por grupo em comparação com o total de menções.',
      type: 'names',
    },
  },
  {
    id: 'LSN_62',
    width: WIDTH.LARGE,
    height: HEIGHT.LARGE,
    component: 'BrandHealthByGroup',
    componentType: COMPONENT_TYPE.DUAL_AXIS,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    hideInLibrary: [Flags.showBrandHealthCards],
    props: {
      title: 'Saúde da Marca por Tema',
      originalTitle: 'Saúde da Marca por Tema',
      isExpandedCard: false,
      description: 'Soma o percentual de menções positivas e neutras por grupo em comparação com o total de menções.',
      type: 'themes',
    },
  },
  {
    id: 'LSN_63',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'StockVsSocialLineChart',
    componentType: COMPONENT_TYPE.STACKED_LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    shareable: false,
    hideInLibrary: [Flags.showStockCards],
    props: {
      title: 'Comparativo preço x menções',
      originalTitle: 'Comparativo preço x menções',
      isExpandedCard: false,
      metricToCompare: 'price',
    },
  },
  {
    id: 'LSN_64',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'StockVsSocialLineChart',
    componentType: COMPONENT_TYPE.STACKED_LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    shareable: false,
    hideInLibrary: [Flags.showStockCards],
    props: {
      title: 'Comparativo volume x menções',
      originalTitle: 'Comparativo volume x menções',
      isExpandedCard: false,
      metricToCompare: 'volume',
    },
  },
  {
    id: 'LSN_65',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'StockVsSentimentLineChart',
    componentType: COMPONENT_TYPE.STACKED_LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.LISTENING,
    shareable: false,
    hideInLibrary: [Flags.showStockCards],
    props: {
      title: 'Comparativo preço x sentimento',
      originalTitle: 'Comparativo preço x sentimento',
      isExpandedCard: false,
      metricToCompare: 'price',
    },
  },
  {
    id: 'LSN_66',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'FileImporter',
    componentType: COMPONENT_TYPE.IMPORT_FILE,
    visible: true,
    notSupportFilter: true,
    dataType: DATA_TYPE.LISTENING,
    hideInLibrary: [Flags.showImporter, Flags.showStudioDev],
    props: {
      title: 'Importar arquivo',
      originalTitle: 'Importar arquivo',
      isExpandedCard: false,
      description: 'Componente para inserir arquivos por arquivo ou via URLs.',
    },
  },
  {
    id: 'LSN_67',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'ImportHistory',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: true,
    dataType: DATA_TYPE.LISTENING,
    shareable: false,
    hideInLibrary: [Flags.showUploadHistory, Flags.showStudioDev],
    props: {
      title: 'Histórico de importação',
      description: 'Componente para vizualizar os registros do histórico de importação',
    },
  },
  {
    id: 'LSN_68',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'TextFilter',
    componentType: COMPONENT_TYPE.SEARCH,
    visible: true,
    notSupportFilter: true,
    dataType: DATA_TYPE.LISTENING,
    shareable: false,
    hideInLibrary: [Flags.showTextSearch, Flags.showStudioDev],
    props: {
      title: 'Busca',
      description: 'Componente para busca textual livre',
    },
  },
  {
    id: 'LSN_69',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'AnnotationsLogs',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: true,
    dataType: DATA_TYPE.LISTENING,
    shareable: false,
    hideInLibrary: [Flags.showListeningAnotationLogs, Flags.showStudioDev],
    props: {
      title: 'Relatório de anotações',
      description: 'Componente para auditoria de anotações e mudança de status',
    },
  },
];
